import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/seguroiprevnumeroparcelas`, options).then(response => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };
  
  return axios
    .get(`${url}/seguroiprevnumeroparcelas/${id}`, options)
    .then(response => {
      let seguroiprevnumeroparcela = jsona.deserialize(response.data);
      delete seguroiprevnumeroparcela.links;
      return seguroiprevnumeroparcela;
    });
}

function add(seguroiprevnumeroparcela) {
  const payload = jsona.serialize({
    stuff: seguroiprevnumeroparcela,
    includeNames: ["categories"]
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  
  //.post(`${url}/seguroiprevnumeroparcelas`, payload, options)
  return axios
    .post(`${url}/seguroiprevnumeroparcelas`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(seguroiprevnumeroparcela) {
  const payload = jsona.serialize({
    stuff: seguroiprevnumeroparcela,
    includeNames: []
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  
  return axios
    .patch(`${url}/seguroiprevnumeroparcelas/${seguroiprevnumeroparcela.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.delete(`${url}/seguroiprevnumeroparcelas/${id}`, options);
}
function downloadPDF(tipo, arquivo) {
  return axios.get(`${url}/downloads/${tipo}/${arquivo}.pdf`, { responseType: 'blob' }).then((response) => {
    return response.data;
  });
}
/*
function upload(seguroiprevnumeroparcela, image) {
  const bodyFormData = new FormData();
  bodyFormData.append("attachment", image);

  return axios
    .post(`${url}/uploads/seguroiprevnumeroparcelas/${seguroiprevnumeroparcela.id}/image`, bodyFormData)
    .then(response => {
      return response.data.url;
    });
}
export default {
  list,
  get,
  add,
  update,
  destroy,
  upload
};
*/
export default {
  list,
  get,
  add,
  update,
  destroy,
  downloadPDF
};